import React, { useState } from "react";
import { apiAdminConfig } from "../utils/api";
import useToast from "../provider/Toast/useToast";

const PreviewImage = ({ file, isDelete = false, id = "", setFieldValue = () => { }, values = {} }) => {
  const toast = useToast();

  const handleDelete = async (id) => {
    await apiAdminConfig.delete(`admin/remove_gallery_file/${id}`).then((response) => {
      if (response?.data.status) {
        let tempData = values?.files ?? []
        tempData = tempData?.filter(list => list?._id != id)
        setFieldValue("files", tempData)
        toast({
          message: response?.data?.message,
          bg: 'success'
        });
      } else {
        toast({
          message: response?.data?.message,
          bg: 'danger'
        });
      }
    }).catch((error) => {
      console.log("invoiceError", error)
      const { response } = error
      toast({
        message: response?.data?.message,
        bg: "danger",
      });
    })
  }

  return (
    <div style={{
      position: 'relative'
    }}>
      <img src={file} alt="preview" width="100px" height="100px" />
      {(isDelete && !!id) && <div style={{
        position: 'absolute',
        top: '-12px',
        right: '-12px',
        borderRadius: '50%',
        width: '30px',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{
          width: '30px',
          height: '30px',
          fill: '#000',
          cursor: 'pointer'
        }} onClick={() => handleDelete(id)}>
          <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" />
        </svg>
      </div>}
    </div>
  );
};

export default PreviewImage;